import { type AdnConfig, debugLog } from '@schibsted-nmp/advertising-shared';

import { Api } from './Api/index.js';

export async function initiateAdn(
  adnConfig: AdnConfig,
  ...abortSignals: ReadonlyArray<AbortSignal>
) {
  const adn = await Api(...abortSignals);

  const eventNames = [
    'render',
    'request',
    'load',
    'impression',
    'click',
    'error',
    'complete',
    'visibilityChange'
  ];

  for (const eventName of eventNames) {
    adn.util.addEventListener(window, eventName, (event) => {
      debugLog(`Adn event: ${eventName}`, event);
    });
  }

  debugLog('Adn initialized', adnConfig);
}
